// Libraries
import * as Yup from 'yup';

export const trackingSchema = Yup.object().shape({
    numberSearch: Yup.string()
        .matches(/^[0-9]+$/, 'No es un numero')
        .length(11, 'Numero no valido')
        .required('Requerido')
})